enum PropensityLevel {
  HIGH = 'HIGH',
  MEDIUM = 'MEDIUM',
  LOW = 'LOW',
  NONE = 'NONE'
}

export const PROPENSITY_DEFAULT = PropensityLevel.MEDIUM;

export default PropensityLevel;
